import { hasCapability, type User } from "../base";

const canAccessDropboxSign = (user: User, organizationId: string) => {
  if (hasCapability(user, "dropboxSign.access.all")) {
    return true;
  }
  return user.person.organizationId === organizationId && hasCapability(user, "dropboxSign.access.org");
};

export const dropboxSign = {
  create: canAccessDropboxSign,
  read: canAccessDropboxSign,
};
